import { render, staticRenderFns } from "./StartApproval.vue?vue&type=template&id=0946896c&"
import script from "./StartApproval.vue?vue&type=script&lang=js&"
export * from "./StartApproval.vue?vue&type=script&lang=js&"
import style0 from "./StartApproval.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports